import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import App from "./app/App";
import msalInstance, { ensureMsalInitialized } from "./app/auth/msalInstance";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");

const start = async () => {
  try {
    await ensureMsalInitialized();
  } catch (e) {
    console.warn("MSAL instance init failed", e);
  }

  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
    container
  );
};

start();

reportWebVitals();
